import React, { useEffect } from "react";
import { format } from "date-fns";
import { Icon } from "@iconify/react"; 
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import StringToReactComponent from "string-to-react-component";
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { nArabicWords } from "narabicwords";
import { axiosUpload } from "../../services/axios";
import { useAppStore } from "../../zustand/useAppStore";
import { SetupCustomStates } from "../lib/SetupCustom";
import { showConfirm } from "../../components/showConfirm";
import { CustomInput, selectStyles } from "../lib/CustomStyles";
import ERPComponentBuilder from "../ERPComponentBuilder";
import Dynamic from "../Dynamic";
import { useAuthStore } from "../../zustand/useAuthStore";







export const CustomComponent = ({ components, dataType, onReady }) => { 






function SetupCustomStates(components) {

var variablesSrc= ``;



 const comp_id = components.comp_id;
 const customDetails = components.details?.fetchingdata;

     if(customDetails.length > 0){

      for(var j=0; j<customDetails.length ; j++){

       variablesSrc = variablesSrc + 
       `
       const SYS${customDetails[j].id} = CustomData_["${comp_id}_${customDetails[j].id}"] || null;
       const [${customDetails[j].id} , set${customDetails[j].id}] = React.useState([]); 
       const [${customDetails[j].id}_ , set${customDetails[j].id}_] = React.useState([]); 

      
       React.useEffect(() => {
       
        if(!SYS${customDetails[j].id})return;
        
        set${customDetails[j].id}(SYS${customDetails[j].id});
        set${customDetails[j].id}_(SYS${customDetails[j].id});
        //console.log("Added SYS${customDetails[j].id}")
      }, [SYS${customDetails[j].id}]);
      
        `

      }

    }
    

return variablesSrc
}




  const { Get, Post, Update, Delete, setLoading, setShowModal, setComponentLoading } = useAppStore();

  const maindata = useSelector((state) => state.cart.maindata);
  const auth = useSelector((state) => state.cart.auth);
  const CustomData = useSelector((state) => state.cart.customData);
  const modalCustomData = useSelector((state) => state.cart.modalCustomData);
  
  const dispatch = useDispatch();
  const token = ''; // ⚠️ Ensure you pass the correct token logic here when needed

  /* =========================================
     🌟 REDUX DISPATCH HELPER FUNCTIONS
     ========================================= */
  const setFetchedMainData = (payload) => dispatch({ type: 'cart/setFetchedMainData', payload });
 









  useEffect(() => {
    if (typeof onReady === 'function') {
      const timer = setTimeout(() => {
        onReady(components?.comp_id);
      }, 50);
      
      return () => clearTimeout(timer);
    }
  }, [components?.comp_id, onReady]); 

  const RefreshSpecificMainData = async (Component_id, data, api) => {
    setComponentLoading({ compId: Component_id, value: true });
    let recordData_ = { ...maindata };
    
    try {
      const res = await Post("", api, data);
      if (res.success) {
        recordData_ = { ...recordData_, [`TL_${Component_id}`]: res.data };
        setFetchedMainData(recordData_);
      } else {
        toast.error(res.msg);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setComponentLoading({ compId: Component_id, value: false });
    }
  };
  
  const RefreshMainData = async () => {
    let arr = {};
    try {
      if (maindata.length > 0) {    
        setLoading(true);
        for (let int_i = 0; int_i < maindata.length; int_i++) {
           const res = await Get("", maindata[int_i].api, `limit=${Number(maindata[int_i].details.limit)}&${maindata[int_i].details.apiData}`);
           if (res.success) {    
            arr = { ...arr, [`TL_${maindata[int_i].comp_id}`]: res.data };    
           }
        }
        setFetchedMainData(arr);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  function CloseModal() { 
    setShowModal(false);
  }



  let CustomData_ = [];
  if (dataType === 'main') {
    CustomData_ = CustomData || {} ;
  } else {
    CustomData_ = modalCustomData || {};
  }

  function sourceCode(components) { 
     return  components?.details.source || "NO Source Provided";
  }
  
  return (
       <StringToReactComponent  
          key={`${components?.comp_id}`} 
          data={{ 
            Icon, showConfirm, ERPComponentBuilder, Dynamic,
            axiosUpload, useAppStore, useAuthStore, auth, 
            format, CustomData_, nArabicWords, 
            Select, DatePicker, CustomInput, selectStyles, toast,
            Post, Get, Update, Delete, token, CloseModal, 
            useDispatch, useSelector, 
            RefreshMainData, RefreshSpecificMainData,  
          }} 
       >
          {`
            (props) => { 
              const { 
                Icon, showConfirm, ERPComponentBuilder, Dynamic,
            axiosUpload, useAppStore, useAuthStore, auth, 
            format, CustomData_, nArabicWords, 
            Select, DatePicker, CustomInput, selectStyles, toast,
            Post, Get, Update, Delete, token, CloseModal, 
            useDispatch, useSelector, 
            RefreshMainData, RefreshSpecificMainData, 
              } = props;
              
              ${SetupCustomStates(components)}
              
              ${sourceCode(components)}
            
}`}
       </StringToReactComponent>
  );
};